import { Language } from '../constants';
import { useLanguage } from './use-language';

export enum Locale {
  deCh = 'de-CH',
  frCh = 'fr-CH',
  enUs = 'en-US',
  plPl = 'pl-PL',
}

const LANGUAGE_TO_LOCALE_MAP: Record<Language, Locale> = {
  [Language.de]: Locale.deCh,
  [Language.fr]: Locale.frCh,
  [Language.en]: Locale.enUs,
  [Language.pl]: Locale.plPl,
};

export const useLocale = () => {
  const language = useLanguage();
  return LANGUAGE_TO_LOCALE_MAP[language];
};
